import shiftService from "../service/ShiftService";

export const fetchShifts = () => async (dispatch) => {
  dispatch({ type: "FETCH_SHIFTS_REQUEST" });
  try {
    const response = await shiftService.getShifts();
    const activeShifts = response.data.resultSet.filter(shift => shift.status === "A");
    dispatch({
      type: "FETCH_SHIFTS_SUCCESS",
      payload: activeShifts,
    });
  } catch (error) {
    console.error("Error fetching shifts", error);
    dispatch({ type: "FETCH_SHIFTS_FAILURE" });
  }
};

export const postShift = (shiftData) => async (dispatch) => {
  dispatch({ type: "POST_SHIFT_REQUEST" });
  try {
    await shiftService.postShift(shiftData);
    dispatch({ type: "POST_SHIFT_SUCCESS" });
    dispatch(fetchShifts()); // Refresh shifts
  } catch (error) {
    console.error("Error posting shift", error);
    dispatch({ type: "POST_SHIFT_FAILURE", payload: error.message });
  }
};